import React from "react";
import { DragLayerMonitorProps } from "@minoru/react-dnd-treeview";
import { TypeIcon } from "./TypeIcon";
import styles from "./DraggedNode.module.css";

type Props = {
  monitorProps: DragLayerMonitorProps<any>;
};

export const DraggedNode: React.FC<Props> = (props) => {
  const item = props.monitorProps.item;

  return (
    <div className={styles.root}>
      <div className={styles.icon}>
        <TypeIcon droppable={!!item?.droppable} fileType={item?.data?.fileType} />
      </div>
      <div className={styles.label}>{item.text}</div>
    </div>
  );
};
